<template>
  <div class="animated fadeIn brief-adicionales-abm">
    <b-row>
      <b-col cols="12">
        <b-card header="Solicitud de Adicionales">
          <form>
            <b-form-group
              description="Descripción del adicional solicitado">
              <b-form-textarea
                id="adicionales"
                v-model="$v.adicionales.$model" 
                rows="5"
                max-rows="5"
                :state="adicionalesValidos"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="adicionalesFeedback">
                {{ adicionalesInvalidosMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Fecha Entrega"
              label-for="fechaEntrega"
              :label-cols="labelCols">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <b-form-checkbox 
                      id="fechaEntregaHabilitada"
                      v-model="fechaEntregaHabilitada"
                      value= true
                      unchecked-value= false>
                  </b-form-checkbox>
                </b-input-group-prepend>
                <b-form-input 
                  id="fechaEntrega" 
                  v-model="$v.fechaEntrega.$model" 
                  type="datetime-local"
                  :disabled="fechaEntregaDisabled"
                  :state="fechaEntregaValida"
                  @blur.native="validate">
                </b-form-input>
              </b-input-group>
              <b-form-invalid-feedback id="fechaEntregaFeedback">
                {{ fechaEntregaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </form>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-card class="galeria-imagenes">
          <template slot="header">
            Imágenes de Referencia

            <i class="fa fa-plus"
              id="add-imagen"
              v-if="!agregandoImagenes"
              @click.prevent="agregandoImagenes = true" />
          </template>
          
          <b-row>
            <b-col cols="12">
              <image-uploader
                v-if="agregandoImagenes"
                :debug="1"
                :maxWidth="1024"
                :maxHeight="2048"
                :quality="0.7"
                :autoRotate=false
                outputFormat="verbose"
                :preview=false
                :className="['fileinput', { 'fileinput--loaded' : true }]"
                :capture="true"
                accept=".jpg,.png,.jpeg,.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.zip,.rar,.ai,.psd"
                doNotResize="['gif', 'svg', 'pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'zip', 'rar', 'ai', 'psd']"
                @onUpload="uploadingImage"
                @input="setImage"
                @inputNoResize="setImageNoResize"
                @cancel="cancelarAgregarImagen">
              </image-uploader>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="4" v-for="imagen in imagenes" :key="imagen.id">
              <b-card no-header class="galeria-imagen">
                <template v-if="isImagen(imagen.fileName)">
                  <b-img fluid
                    @click="consultarImagen(imagen.url)"
                    :src="imagen.url"></b-img>
                </template>
                <template v-if="isPDF(imagen.fileName)">
                  <div class="galeria-pdf">
                    <div @click="consultarPDF(imagen)">
                      <pdf 
                        :src="imagen.url"
                        :page="1"
                        :scale="0.8"/>
                    </div>
                  </div>
                </template>
                <template v-if="isWord(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-word-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isPowerPoint(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-powerpoint-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isExcel(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file-excel-o fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <template v-if="isOtro(imagen.fileName)">
                  <div class="galeria-doc">
                    <i class="fa fa-file fa-2x" @click="downloadFile(imagen)"></i>
                    <label @click="downloadFile(imagen)">{{ imagen.fileName }}</label>
                  </div>
                </template>
                <div class="titulo">
                  <h3 v-if="imagen.titulo != ''">{{ imagen.titulo }}</h3>
                </div>
                <div class="footer">
                  <b-button size="sm" variant="danger" class="footer-button" 
                    @click.prevent="borrarImagen(imagen.id)">Borrar</b-button>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="imagenModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen">
      <app-imagen
        :url="selectedImageUrl"
        @close="closeImagen">
      </app-imagen>  
    </b-modal>

    <b-modal ref="pdfModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalImagen modalPDF">
      <app-pdf-modal
        :filename="selectedFilename"
        :url="selectedImageUrl"
        @close="closePDF">
      </app-pdf-modal>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>  

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import ImageUploader from '../../components/ImageUploader.vue';
import Imagen from  '../shared/imagenModal.vue';
import PdfModal from  '../shared/pdfModal.vue';
import pdf from 'vue-pdf'
import ABMButtons from '../shared/abmButtons.vue';
import { required, maxLength } from 'vuelidate/lib/validators';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'briefAdicional/getField',
  mutationType: 'briefAdicional/updateField',
});

export default {
  name: 'BriefAdicionalAdd',
  components: {
    ImageUploader,
    appImagen: Imagen,
    appPdfModal: PdfModal,
    pdf,
    appABMButton: ABMButtons,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      agregandoImagenes: false,
      selectedFilename: '',
      selectedImageUrl: '',

      noValidar: true,
      adicionalesValidos: null,
      adicionalesInvalidosMsj: '',
      fechaEntregaValida: null,
      fechaEntregaInvalidaMsj: '',

      fechaEntregaDisabled: true,
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'adicionales',
      'fechaEntrega',
      'fechaEntregaHabilitada',
      'imagenes'
    ])
  },
  created() {
    let briefId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        briefId = this.$route.params.id;
      }
    }
    this.showSpinner();
    this.$store.dispatch('briefAdicional/inicializar', briefId)
      .then(() => {
        this.fechaEntregaDisabled = !(/true/i).test(this.fechaEntregaHabilitada);        
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'adicionales' || validarTodos) {
        if (this.$v.adicionales.$error) {
          this.adicionalesValidos = false;
          if (!this.$v.adicionales.required) {
            this.adicionalesInvalidosMsj = 'Debe ingresar el detalle del adicional solicitado';
          } else if (!this.$v.adicionales.maxLength) {
            this.adicionalesInvalidosMsj = 'El detalle del adicional solo puede contener hasta 5000 caracteres';
          }      
        } else {
          this.adicionalesValidos = null;
          this.adicionalesInvalidosMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('briefAdicional/save')
            .then(() => this.showModalMsj('La solicitud de adicionales se registró con éxito.', this.goBack, this.goBack))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'Briefs' });
    },

    isImagen(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'jpg' 
          || extension.toLowerCase() == 'png') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'jpeg') {
        return true;
      }

      return false;
    },
    isPDF(fileName) {
      let extension = fileName.slice(-3);
      if (extension == 'pdf') {
        return true;
      }
      return false;
    },
    isWord(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'doc') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'docx') {
        return true;
      }

      return false;
    },
    isPowerPoint(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'ppt') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'pptx') {
        return true;
      }

      return false;
    },
    isExcel(fileName) {
      let extension = fileName.slice(-3);
      if (extension.toLowerCase() == 'xls') {
        return true;
      }

      extension = fileName.slice(-4);
      if (extension.toLowerCase() == 'xlsx') {
        return true;
      }

      return false;
    },
    isOtro(fileName) {
      return !this.isImagen(fileName)
        && !this.isPDF(fileName)
        && !this.isWord(fileName)
        && !this.isPowerPoint(fileName)
        && !this.isExcel(fileName);
    },

    agregarImagen() {
      this.agregandoImagenes = true;
    },
    cancelarAgregarImagen() {
      this.agregandoImagenes = false;
    },
    uploadingImage () {
      this.showSpinner();
    },
    setImage(output) {
      var file = this.dataURLtoFile(output.dataUrl, output.info.name);
      
      if (file) {
        this.$store.dispatch('briefAdicional/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }
    },
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]), 
            n = bstr.length, 
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    setImageNoResize(file) {
      if (file) {
        this.$store.dispatch('briefAdicional/uploadImagen', file)
          .then(() => this.key++)
          .catch(error => this.showErrorMsj(error))
          .finally(() => {
            this.agregandoImagenes = false;
            this.hideSpinner();
          });
      } else {
        this.hideSpinner();
      }   
    },
    consultarImagen(imageUrl) {
      this.selectedImageUrl = imageUrl;
      this.$refs.imagenModal.show();
    },
    closeImagen() {
      this.$refs.imagenModal.hide();
    },
    consultarPDF(file) {
      this.selectedImageUrl = file.url;
      this.selectedFilename = file.fileName;
      this.$refs.pdfModal.show();
    },
    closePDF() {
      this.$refs.pdfModal.hide();
    },
    consultarDocumento(url) {
      window.open(url, '_blank');
    },
    downloadFile(file) {
      if (file.url) {
        fetch(file.url)
          .then(res => res.blob())
          .then(blob => {
            saveAs(blob, file.fileName);
          });
      }
    },    
    borrarImagen(imagenId) {
      this.showModalConfirm('¿Desea eliminar el documento seleccionado?', 
        this.borrarImagenSeleccionada.bind(this, imagenId), 'Si', 
        null, 'No');
    },
    borrarImagenSeleccionada(imagenId) {
      this.$store.dispatch('briefCambio/deleteImagen', imagenId)
        .then(() => this.key++)
        .catch(error => this.showErrorMsj(error));
    },
  },
  validations: {
    adicionales: {
      required,
      maxLength: maxLength(5000)
    },
    fechaEntrega: {}
  },  
  watch: {
    'fechaEntregaHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaDisabled = !(/true/i).test(this.fechaEntregaHabilitada);
    }
  }    
}
</script>

<style>
  .brief-adicionales-abm .galeria-imagen {
    border: none;
    /* padding-top: 20px; */
    text-align: center;
  }
  .brief-adicionales-abm .galeria-imagen .card-body {
    padding: 0;
  }
  .brief-adicionales-abm .galeria-imagen img {
    position: relative;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .brief-adicionales-abm .galeria-imagen .footer {
    height: 40px;
    display: inline-block;
    width: 100%;
  }
  .brief-adicionales-abm .galeria-imagen .footer button {
    display: none;
    margin-right: 0;
    width: 100%;
  }
  .brief-adicionales-abm .galeria-imagen:hover .footer button {
    display: inline-block;
  }
  @media(max-width:766px){
    .brief-adicionales-abm .galeria-imagen .footer button {
      display: inline-block;
    }
  }

  /* .brief-adicionales-abm .galeria-imagen, */
  .brief-adicionales-abm .galeria-pdf {
    max-height: 160px !important;
    overflow: hidden;
  }
  .brief-adicionales-abm .galeria-pdf > div {
    cursor: pointer;
  }

  .brief-adicionales-abm .galeria-doc {
    display: block;
  }
  .brief-adicionales-abm .galeria-doc i,
  .brief-adicionales-abm .galeria-doc label {
    display: block;
    cursor: pointer;
  }
  .brief-adicionales-abm .galeria-doc i {
    color: rgb(20,76,129);
    margin-bottom: 10px;
  }
  .brief-adicionales-abm .galeria-doc label {
    margin-bottom: 20px;
  }

  .brief-adicionales-abm .subtitulo,
  .brief-adicionales-abm .subtitulo label,
  .brief-adicionales-abm .subtitulo button {
    display: inline-block !important;
  }

  .brief-adicionales-abm #add-imagen {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-adicionales-abm #add-imagen:hover {
    color: #1b8eb7;
  }


  .brief-adicionales-abm .dropdown-menu li {
    list-style: none !important;
  }
  .brief-adicionales-abm .titulo p {
    font-size: 0.8em;
  }

  .brief-adicionales-abm #add-imagen {
    position: relative;
    margin-left: 10px;
    cursor: pointer;
    color: #20a8d8;
  }
  .brief-adicionales-abm #add-imagen:hover {
    color: #1b8eb7;
  }


</style>